import React, { useState } from "react";
import { Topbar, Alert } from "@components";
import { useNavigate } from "react-router-dom";
import {
  CopyLink,
  CopyTitle,
  InviteLinkContainer,
  InviteLinkTerms,
  InviteLinkTitle,
  Button,
  ButtonText,
  Divider,
  FooterContainer,
  CancelButton,
  CopyButton,
  Modal,
} from "./InviteLink.style";
// import { Modal } from "antd";
import { InviteLinkFilled, AddFilled } from "@assets";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { api } from "@api";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { openAlert } from "@redux/app/appSlice";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";
import { localStorage } from "@utils";

const InviteLink = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [textToCopy, setTextToCopy] = useState("");

  const userPreferedLanguage = localStorage.getUserPreferedLanguage();
  const { invite_link_rule } = useSelector((state) => state.app.settings);

  const inviteLinkRule =
    userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
      ? invite_link_rule?.text_en
      : userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
      ? invite_link_rule?.text_mm
      : invite_link_rule?.text_ch;

  const getInviteLink = () => {
    setLoading(true);
    api
      .postReferral()
      .then(({ referral_id }) => {
        const domain = window.location.hostname;
        setLoading(false);
        setTextToCopy(`${domain}/register?referral_id=${referral_id}`);
        setIsOpen(true);
      })
      .catch((errorMsg) => {
        setLoading(false);
        showAlert({
          message: errorMsg,
          isError: true,
        });
      });
  };

  const handleCopyClick = () => {
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setIsOpen(false);
        showAlert({
          message: t("common.copied"),
          successCallback: goBack,
        });
      })
      .catch((error) => {
        //create input or text area
        const input = document.createElement("input");
        input.setAttribute("value", textToCopy);
        document.body.appendChild(input);
        input.select();
        const result = document.execCommand("copy");
        document.body.removeChild(input);
        if (result) {
          setIsOpen(false);
          showAlert({
            message: t("common.copied"),
            successCallback: goBack,
          });
        } else {
          alert("Failed to copy to clipboard.");
        }

        console.error("Failed to copy: ", error);
      });
  };

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.PROFILE}`);
  };

  const showAlert = (data) => {
    dispatch(openAlert(data));
  };

  const ModalFooter = () => (
    <FooterContainer>
      <CancelButton onClick={() => setIsOpen(false)}>
        {t("common.cancel")}
      </CancelButton>
      <CopyButton onClick={handleCopyClick}>{t("common.copy")}</CopyButton>
    </FooterContainer>
  );

  return (
    <>
      <Topbar title={t("profile.inviteLink")} goBack={goBack} />
      <InviteLinkContainer>
        <InviteLinkFilled style={{ marginTop: "4em" }} />
        <InviteLinkTitle>{t("profile.inviteLinkSubtitle")}</InviteLinkTitle>
        <Button onClick={getInviteLink} loading={loading}>
          <ButtonText>
            {t("common.create")} <AddFilled />
          </ButtonText>
        </Button>
        <Divider>{t("profile.inviteLinkTerms")}</Divider>
        <InviteLinkTerms dangerouslySetInnerHTML={{ __html: inviteLinkRule }} />
      </InviteLinkContainer>
      <Modal
        open={isOpen}
        closable={false}
        footer={<ModalFooter />}
        centered={true}
        onCancel={() => setIsOpen(false)}
        width={326}
        height={128}
      >
        <div style={{ textAlign: "center" }}>
          <CopyTitle>{t("common.invitedText")}</CopyTitle>
          <CopyLink>{textToCopy}</CopyLink>
        </div>
        {/* <CopyFilled onClick={handleCopyClick} /> */}
      </Modal>
      <Alert />
    </>
  );
};

export default InviteLink;
